// extracted by mini-css-extract-plugin
module.exports = {"invoice-section":"InvoiceLineTable_invoice-section__2s7RZ"};